// extracted by mini-css-extract-plugin
export default {"root":"CustomFormikSelect_root__fqV4T","errorMessage":"CustomFormikSelect_errorMessage__fg7H-"};